import posthog from 'posthog-js';

const POSTHOG_KEY = (import.meta as any).env?.VITE_POSTHOG_KEY as string | undefined;
const POSTHOG_HOST = ((import.meta as any).env?.VITE_POSTHOG_HOST as string | undefined) ?? 'https://us.i.posthog.com';
const DISABLE_ANALYTICS = String((import.meta as any).env?.VITE_DISABLE_ANALYTICS ?? 'false')
  .toLowerCase()
  .trim() === 'true';

let initialized = false;

export const initPosthog = () => {
  if (initialized || typeof window === 'undefined' || DISABLE_ANALYTICS || !POSTHOG_KEY) {
    return;
  }

  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    autocapture: true,
    capture_pageview: false,
    persistence: 'localStorage+cookie',
    respect_dnt: true,
  });

  initialized = true;
};

export const captureEvent = (event: string, properties?: Record<string, unknown>) => {
  if (!initialized || DISABLE_ANALYTICS) {
    return;
  }

  posthog.capture(event, properties);
};
